import { toast } from "sonner";

export async function copyText(text, ok = "Copied") {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(ok);
  } catch {
    toast.error("Couldn't copy — select the text and copy it manually");
  }
}
